import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';

const Number = withStyles(styles)(({ classes, i, treeTrace, error, onChange, value, mode }) => {
  const { field, label, direction, disabledOnEdit, validate } = i;

  return (
    <div className={classes.inputContainer}>
      <p
        style={{ marginBottom: 5, fontWeight: 400 }}
        className={cn(
          classes.inputLabel,
          disabledOnEdit && mode === 'EDIT' && classes.disabledText,
          error && classes.textLabelError,
        )}
      >
        {label}: {!!error && error}
      </p>
      <input
        type="number"
        value={value}
        disabled={disabledOnEdit && mode === 'EDIT'}
        className={cn(
          classes.input,
          classes.textInput,
          error && classes.textInputError,
          disabledOnEdit && mode === 'EDIT' && classes.disabledInput,
        )}
        onChange={evt => onChange(field, evt.target.value, treeTrace)}
        {...i}
      />
    </div>
  );
});

export default Number;
